import apiTrainings from '@/api/trainings'
import {equals, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getTrainingsListStart: '[trainings] Get training list start',
  getTrainingsListSuccess: '[training] Get trainings list success',
  getTrainingsListFailure: '[training s] Get trainings list failure'
}

export const actionTypes = {
  getTrainingsList: '[trainings] Get training list'
}

const mutations = {
  [mutationTypes.getTrainingsListStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingsListSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingsListFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getTrainingsList](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(equals('')))
    )(data)

    context.commit(mutationTypes.getTrainingsListStart)
    return new Promise(resolve => {
      apiTrainings
        .getTrainingsList(params)
        .then(response => {
          context.commit(mutationTypes.getTrainingsListSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingsListFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
